import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injectable, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, QuotePro } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'quote-template-picker',
    templateUrl: './quote.template.picker.component.html',
    styleUrls: ['./quote.template.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: QuoteTemplatePickerComponent, multi: true }
    ],
    standalone: false
})
export class QuoteTemplatePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Quote Template>';
  @Input() public appendTo: any;
  @Input() public multiple: boolean;
  @Input() public clearable: boolean;


  public data$: Observable<Entity[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private templates: QuoteTemplatePickerService
  ) {
    super(injector);
    this.fetch = PickerFetch.Automatic;
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getTemplates()
      : of(this.data);

  }

  private getTemplates(): Observable<Entity[]> {
    return this.templates.getTemplates();
  }
}


@Injectable({ providedIn: 'root' })
export class QuoteTemplatePickerService {

  constructor(
    private http: HttpClient
  ) { }

  public getTemplates(): Observable<Entity[]> {
    return this.http.get<Entity[]>(`/api/picker/quote-templates`);
  }

  public getTemplate(id: string): Observable<QuotePro> {
    return this.http.get<QuotePro>(`/api/picker/quote-templates/${id}`);
  }

}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    QuoteTemplatePickerComponent
  ],
  providers: [],
  exports: [
    QuoteTemplatePickerComponent
  ],
})
export class QuoteTemplatePickerModule { }
